import React, { useEffect } from 'react';

// Per-page <head>.
//
// NOTE: this deliberately does NOT use react-helmet-async. The app runs React
// 19, where helmet-async v2 silently drops every meta/link child (only <title>
// survived), which left every page sharing one description and one canonical.
// React 19 hoists <title>, <meta> and <link> into <head> on its own, so plain
// elements are both simpler and correct. JSON-LD still needs manual injection —
// React does not hoist ld+json script tags.
function SEO({
  title,
  description,
  image,
  url,
  type = 'website',
  noindex = false,
  schema = null,
}) {
  var siteUrl = 'https://www.jimendez.com';
  var defaultImage = 'https://static.wixstatic.com/media/4a2ebb_895ee36e15ba4f70aee1a0473dc735c4~mv2.jpg';

  var fullTitle = title ? title + ' | JiMendez.com' : 'Isaías Jiménez | Innovative Gear for Wind Players';
  var fullUrl = url ? siteUrl + url : siteUrl;
  var fullImage = image || defaultImage;
  var fullDescription = description || 'Shop innovative gear for wind players by pro trumpet player Isaías Jiménez. NoteTurner, MuteClip, BelloFlex mutes & more.';

  var blocks = schema ? (Array.isArray(schema) ? schema : [schema]).filter(Boolean) : [];
  var blocksKey = JSON.stringify(blocks);
  // A noindex page with no path of its own (404, product-not-found) must not
  // canonicalise itself to the homepage.
  var showCanonical = Boolean(url) || !noindex;

  useEffect(function() {
    var nodes = blocks.map(function(block, i) {
      var el = document.createElement('script');
      el.type = 'application/ld+json';
      el.setAttribute('data-seo-schema', String(i));
      el.text = JSON.stringify(block);
      document.head.appendChild(el);
      return el;
    });
    return function() {
      nodes.forEach(function(el) { if (el.parentNode) el.parentNode.removeChild(el); });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocksKey]);

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {showCanonical ? <link rel="canonical" href={fullUrl} /> : null}
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1'} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="JiMendez.com" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />
    </>
  );
}

export default SEO;
